import API from '@/api/base'

API.define('subscription', {
  start: '',
  end: '',
  amount: '',
  count: '',
  periodicity: '',
  profile_id: '',
  item: {},
  order: {
    jsonApi: 'hasOne',
    type: 'order',
  },
  customer: {
    jsonApi: 'hasOne',
    type: 'customer',
  },
  site: {
    jsonApi: 'hasOne',
    type: 'site',
  },
})

export const state = {
  subscriptions: [],
  pageTotal: 0,
  currentPage: 1,
}

export const getters = {
  getSubscriptions: ({ subscriptions }) => subscriptions,
  getCurrentPage: ({ currentPage }) => currentPage,
  getPageTotal: ({ pageTotal }) => pageTotal,
}

export const actions = {
  fetchSubscriptions: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      API.one('customer', params.customerId)
        .all('subscription')
        .get()
        .then((response) => {
          commit('SET_SUBSCRIPTIONS', response.data)
          commit('SET_PAGE_TOTAL', response.meta.documents)
          commit('SET_CURRENT_PAGE', response.meta.pagination.current)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),

  deleteSubscription: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      API.one('customer', params.customerId)
        .one('subscription', params.subscriptionId)
        .destroy()
        .then((response) => {
          commit('REMOVE_SUBSCRIPTION', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response)
        })
    }),
}

export const mutations = {
  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions
  },

  SET_PAGE_TOTAL(state, total) {
    state.pageTotal = total
  },

  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page
  },
}
